import { Date } from '@types';

const DEFAULT_DURATION_MINUTES = 5;

const sessionExtender = session => {
  const expiresAt = new Date().add(DEFAULT_DURATION_MINUTES, 'minutes').toDate();

  return { ...session, expiresAt };
};

export default sessionExtender;
